import { sendGTMEvent } from '@next/third-parties/google';
import { SERVER_CONVERSION_EVENTS, takeConversionEventId } from '@utils/analytics/conversion-event-id';

type EventPayload = { [key: string]: unknown };

/**
 * !!! The sendGoogleTagEvent function will handle all the logic for sending Google Tag Manager events !!!
 * @description Wrapper function for sending Google Tag Manager events
 * @param eventName - The name of the event to send
 * @param type - The type of event (e.g., 'Pageview', 'Click', etc.)
 * @param payload - Optional additional data to include with the event.
 */
export default function sendGoogleTagEvent(
  eventName: string,
  type: string,
  payload?: EventPayload,
) {
  const eventParams: EventPayload = {
    type: `${type}`,
    platform: 'react',
    ...payload,
  };

  // Same id as the backend's server-side conversion, so Google Ads counts the two once.
  if (SERVER_CONVERSION_EVENTS.includes(eventName) && eventParams.transaction_id === undefined) {
    const transactionId = takeConversionEventId(eventName);
    if (transactionId) {
      eventParams.transaction_id = transactionId;
    }
  }

  sendGTMEvent({
    event: 'ga4_event',
    ga4_event_name: eventName,
    ga4_parameters: eventParams,
  });
}
